export default "__VITE_ASSET__BpNbNNZu__"